module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonerebranding-intro-card1.2@2x.8eff57a0.jpg";